"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEditableLegalConsentKeysForLegalConsentType = getEditableLegalConsentKeysForLegalConsentType;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _LegalConsent = require("../constants/LegalConsent");

var _isEmpty = _interopRequireDefault(require("hs-lodash/isEmpty"));

var _isEqual = _interopRequireDefault(require("hs-lodash/isEqual"));

var _findIndex = _interopRequireDefault(require("hs-lodash/findIndex"));

var _Record2;

var keyedText = function keyedText(key, options) {
  return _I18n.default.text("gdpr." + key, options);
};

var DEFAULT_LEGITIMATE_INTEREST_LEGAL_BASIS = 'LEGITIMATE_INTEREST_PQL';
var DEFAULT_OPTIONS = {
  checkboxOptions: []
};

function getEditableLegalConsentKeysForLegalConsentType(legalConsentType) {
  switch (legalConsentType) {
    case _LegalConsent.LegalConsentOptions.IMPLICIT_CONSENT:
      return [_LegalConsent.EditableLegalConsentKeys.COMMUNICATION_CONSENT_TEXT, _LegalConsent.EditableLegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, _LegalConsent.EditableLegalConsentKeys.PRIVACY_POLICY_TEXT, _LegalConsent.EditableLegalConsentKeys.PROCESSING_CONSENT_TEXT];

    case _LegalConsent.LegalConsentOptions.SEPERATE_CONSENT:
      return [_LegalConsent.EditableLegalConsentKeys.COMMUNICATION_CONSENT_TEXT, _LegalConsent.EditableLegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, _LegalConsent.EditableLegalConsentKeys.PROCESSING_CONSENT_TEXT, _LegalConsent.EditableLegalConsentKeys.PROCESSING_CONSENT_CHECKBOX_LABEL, _LegalConsent.EditableLegalConsentKeys.PROCESSING_CONSENT_FOOTER_TEXT, _LegalConsent.EditableLegalConsentKeys.PRIVACY_POLICY_TEXT];

    case _LegalConsent.LegalConsentOptions.LEGITIMATE_INTEREST:
      return [_LegalConsent.EditableLegalConsentKeys.SUBSCRIPTION_TYPES, _LegalConsent.EditableLegalConsentKeys.LAWFUL_BASIS, _LegalConsent.EditableLegalConsentKeys.PRIVACY_POLICY_TEXT];

    default:
      return [];
  }
}

var LegalConsent =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(LegalConsent, _Record);

  function LegalConsent() {
    (0, _classCallCheck2.default)(this, LegalConsent);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LegalConsent).apply(this, arguments));
  }

  (0, _createClass2.default)(LegalConsent, [{
    key: "addOrUpdateCommunicationCheckbox",
    value: function addOrUpdateCommunicationCheckbox(newCheckbox) {
      var oldCheckbox = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var currentCheckboxes = this.get(_LegalConsent.LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES);
      var updatedCheckboxes = currentCheckboxes;

      if (!(0, _isEmpty.default)(oldCheckbox)) {
        var updateIndex = (0, _findIndex.default)(currentCheckboxes, {
          communicationTypeId: oldCheckbox.communicationTypeId
        });
        updatedCheckboxes = currentCheckboxes.map(function (value, index) {
          if (index === updateIndex) {
            return newCheckbox;
          }

          return value;
        });
      } else {
        updatedCheckboxes = currentCheckboxes.concat([newCheckbox]);
      }

      return this.set(_LegalConsent.LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, updatedCheckboxes);
    }
  }, {
    key: "removeCheckbox",
    value: function removeCheckbox(removedCheckbox) {
      var currentCheckboxes = this.get(_LegalConsent.LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES);
      return this.set(_LegalConsent.LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, currentCheckboxes.filter(function (_ref) {
        var communicationTypeId = _ref.communicationTypeId;
        return !(0, _isEqual.default)(removedCheckbox.communicationTypeId, communicationTypeId);
      }));
    }
  }, {
    key: "getLegalConsentType",
    value: function getLegalConsentType() {
      var isLegitimateInterest = this.get(_LegalConsent.LegalConsentKeys.IS_LEGITIMATE_INTEREST);
      var processingConsentType = this.get(_LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_TYPE);

      if (!isLegitimateInterest && processingConsentType === _LegalConsent.ProcessingConsentTypes.IMPLICIT) {
        return _LegalConsent.LegalConsentOptions.IMPLICIT_CONSENT;
      } else if (!isLegitimateInterest && processingConsentType === _LegalConsent.ProcessingConsentTypes.REQUIRED_CHECKBOX) {
        return _LegalConsent.LegalConsentOptions.SEPERATE_CONSENT;
      } else if (isLegitimateInterest) {
        return _LegalConsent.LegalConsentOptions.LEGITIMATE_INTEREST;
      }

      return _LegalConsent.LegalConsentOptions.NONE;
    } // Overite method to prevent arrays being cast to immutables

  }, {
    key: "merge",
    value: function merge() {
      var record = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new LegalConsent();
      var updatedRecord = Object.values(_LegalConsent.EditableLegalConsentKeys || {}).reduce(function (memo, key) {
        if ((0, _isEmpty.default)(record.get(key)) || (0, _isEqual.default)(key, _LegalConsent.LegalConsentKeys.PRIVACY_POLICY_TEXT) || (0, _isEqual.default)(key, _LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_TEXT)) {
          return memo;
        }

        return memo.set(key, record.get(key));
      }, this);
      return updatedRecord;
    }
  }], [{
    key: "createLegalConsentFromOption",
    value: function createLegalConsentFromOption() {
      var _options;

      var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _LegalConsent.LegalConsentOptions.IMPLICIT_CONSENT;
      var otherOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;
      var checkboxOptions = otherOptions.checkboxOptions,
          companyName = otherOptions.domain;

      if (option === _LegalConsent.LegalConsentOptions.NONE) {
        return null;
      }

      var proccessingConsentType = option === _LegalConsent.LegalConsentOptions.SEPERATE_CONSENT ? _LegalConsent.ProcessingConsentTypes.REQUIRED_CHECKBOX : _LegalConsent.ProcessingConsentTypes.IMPLICIT;
      var isLegitimateInterest = option === _LegalConsent.LegalConsentOptions.LEGITIMATE_INTEREST;
      var processingConsentTextKey = option === _LegalConsent.LegalConsentOptions.IMPLICIT_CONSENT ? 'implicitProcessingConsentText' : 'explicitProcessingConsentText';
      var privacyPolicyKey = isLegitimateInterest ? 'legitimateInterestPrivacyPolicyText' : 'privacyPolicyText';
      var options = (_options = {}, (0, _defineProperty2.default)(_options, _LegalConsent.LegalConsentKeys.IS_LEGITIMATE_INTEREST, isLegitimateInterest), (0, _defineProperty2.default)(_options, _LegalConsent.LegalConsentKeys.COMMUNICATION_CONSENT_TEXT, otherOptions[_LegalConsent.SettingsKeys.COMMUNICATION_CONSENT_TEXT] || keyedText('communicationConsentText', {
        companyName: companyName
      })), (0, _defineProperty2.default)(_options, _LegalConsent.LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, checkboxOptions), (0, _defineProperty2.default)(_options, _LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_TYPE, proccessingConsentType), (0, _defineProperty2.default)(_options, _LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_TEXT, otherOptions[processingConsentTextKey] || keyedText(processingConsentTextKey, {
        companyName: companyName
      })), (0, _defineProperty2.default)(_options, _LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_CHECKBOX_LABEL, otherOptions[_LegalConsent.SettingsKeys.EXPLICIT_PROCESSING_CONSENT_CHECKBOX_LABEL] || keyedText('explicitProcessingConsentCheckboxLabel', {
        companyName: companyName
      })), (0, _defineProperty2.default)(_options, _LegalConsent.LegalConsentKeys.PRIVACY_POLICY_TEXT, otherOptions[privacyPolicyKey] || keyedText(privacyPolicyKey, {
        companyName: companyName
      })), _options);

      if (isLegitimateInterest && !(0, _isEmpty.default)(checkboxOptions)) {
        options[_LegalConsent.LegalConsentKeys.SUBSCRIPTION_TYPES] = [checkboxOptions[0].communicationTypeId];
      }

      return new LegalConsent(options);
    }
  }]);
  return LegalConsent;
}((0, _immutable.Record)((_Record2 = {}, (0, _defineProperty2.default)(_Record2, _LegalConsent.LegalConsentKeys.IS_LEGITIMATE_INTEREST, false), (0, _defineProperty2.default)(_Record2, _LegalConsent.LegalConsentKeys.COMMUNICATION_CONSENT_TEXT, ''), (0, _defineProperty2.default)(_Record2, _LegalConsent.LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES, []), (0, _defineProperty2.default)(_Record2, _LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_TYPE, _LegalConsent.ProcessingConsentTypes.IMPLICIT), (0, _defineProperty2.default)(_Record2, _LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_TEXT, ''), (0, _defineProperty2.default)(_Record2, _LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_CHECKBOX_LABEL, ''), (0, _defineProperty2.default)(_Record2, _LegalConsent.LegalConsentKeys.PROCESSING_CONSENT_FOOTER_TEXT, ''), (0, _defineProperty2.default)(_Record2, _LegalConsent.LegalConsentKeys.PRIVACY_POLICY_TEXT, ''), (0, _defineProperty2.default)(_Record2, _LegalConsent.LegalConsentKeys.SUBSCRIPTION_TYPES, []), (0, _defineProperty2.default)(_Record2, _LegalConsent.LegalConsentKeys.LAWFUL_BASIS, DEFAULT_LEGITIMATE_INTEREST_LEGAL_BASIS), _Record2)));

exports.default = LegalConsent;